import { WsTicketService } from '~/services';

export const wsTicketStore = new WsTicketService();
